import { type Asset, fetchAssets } from './assets.product.search.service';

export const searchAssets = async (searchText: string): Promise<Asset[]> => {
  const result = await fetchAssets({ searchText });
  return result?.value ?? [];
};
